export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="144" height="27" viewBox="0 0 144 27" fill="none">
            <path
                d="M88.7115 11.3844C90.1145 11.3844 91.5582 10.2576 91.9344 8.86361L92.6969 6.03785C93.0731 4.64639 92.2394 3.51709 90.8364 3.51709H78.6362L77.9041 6.22438H89.9493L89.2885 8.67708H77.2408L75.1362 16.5242H77.7949L79.1826 11.3844H82.6622L86.457 16.5242H90.3255L86.5332 11.3844H88.7115Z"
                fill="white"
            />
            <path d="M118.03 3.51709L107.695 16.5242H110.702L118.599 6.58485L121.126 16.5242H124.135L120.826 3.51709H118.03Z" fill="white" />
            <path
                d="M46.6918 8.66952L47.3526 6.21934H59.3902L60.1197 3.51709H47.9728C46.5698 3.51709 45.1261 4.64639 44.7499 6.03785L43.3088 11.3718H55.3463L54.6855 13.8245H42.6479L41.9185 16.5242H54.0653C55.4683 16.5242 56.912 15.3949 57.2882 14.0034L58.7293 8.66952H46.6918Z"
                fill="white"
            />
            <path
                d="M141.076 16.5242L143.91 6.03785C144.286 4.64639 143.452 3.51709 142.049 3.51709H128.886L125.371 16.5242H128.1L130.896 6.14624H134.694L131.898 16.5242H134.549L137.345 6.14624H141.142L138.346 16.5242H141.076Z"
                fill="white"
            />
            <path d="M61.2915 6.21934H67.323L64.5398 16.5242H67.1959L69.9816 6.21934H76.0131L76.7425 3.51709H62.0235L61.2915 6.21934Z" fill="white" />
            <path d="M91.7715 16.5236H106.46L107.187 13.8239H95.1571L95.8204 11.3712H107.85L108.582 8.66895H93.8938L91.7715 16.5236Z" fill="white" />
            <path d="M94.5542 6.21934H109.243L109.972 3.51709H95.2862L94.5542 6.21934Z" fill="white" />
            <path d="M33.3145 11.3712H40.6524L41.3818 8.66895H34.0465L33.3145 11.3712Z" fill="white" />
            <path d="M17.8965 0H10.4976L16.9611 8.6714L21.6786 5.07176L17.8965 0Z" fill="white" />
            <path d="M25.4374 20.0434H32.8363L26.9065 12.0879L21.8027 15.1708L25.4374 20.0434Z" fill="white" />
            <path d="M39.6126 0H30.3176L14.2463 12.2282H17.764L0 26.9998L30.432 8.66888H26.8736L39.6126 0Z" fill="url(#paint0_linear_540_1419)" />
            <defs>
                <linearGradient id="paint0_linear_540_1419" x1="37.4216" y1="-1.72386e-07" x2="0.273268" y2="27.2648" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
            </defs>
        </svg>
    );
}
